import { z } from 'zod';

function discriminatedUnionWithFallback(discriminator, variants, fallbackSchema, options) {
    const variantMap = new Map(variants.map((v) => [[...v.shape[discriminator].values][0], v]));
    return z
        .custom(() => true)
        .superRefine(async (data, ctx) => {
        if (typeof data !== "object" || data === null) {
            ctx.addIssue({
                code: "invalid_type",
                expected: "object",
                input: data,
                continue: false,
            });
            return;
        }
        const discValue = data[discriminator];
        const isValidDiscriminator = variantMap.has(discValue);
        const targetSchema = variantMap.get(discValue) ?? fallbackSchema;
        const result = await targetSchema.safeParseAsync(data);
        if (!result.success) {
            for (const issue of result.error.issues) {
                const isDiscriminatorError = issue.path.length === 1 && issue.path[0] === discriminator;
                if (isDiscriminatorError && !isValidDiscriminator) {
                    continue;
                }
                ctx.addIssue({ ...issue });
            }
        }
        if (!isValidDiscriminator) {
            if (discValue !== undefined) {
                ctx.addIssue({
                    code: "custom",
                    path: [discriminator],
                    message: options?.discriminatorErrorMessage ?? "Invalid discriminator",
                    input: data,
                });
            }
            else {
                ctx.addIssue({
                    code: "custom",
                    path: [discriminator],
                    message: options?.discriminatorErrorMessage ?? "Required",
                    input: data,
                });
            }
        }
    })
        .meta({ __variants: variants, __discriminator: discriminator });
}

export { discriminatedUnionWithFallback };
